import { apiNames, get, fetchQuery } from '@general/api/shared';

export const getSearchAPIKeyUrl = ({ isAttendeeSearch, eventCode, memberID }) => {
    if (isAttendeeSearch) {
        return `search_token/${memberID}/${eventCode}`;
    }
    if (memberID) {
        return `search_token/${memberID}`;
    }
    if (!memberID) {
        return `search_token`;
    }
};

export const getSearchAPIKey = ({ isAttendeeSearch, eventCode, memberID }) => {
    const url = getSearchAPIKeyUrl({ isAttendeeSearch, eventCode, memberID });

    const fetchRequest = () => get(apiNames.MEMBERSHIP, url);

    return fetchQuery({ fetchRequest });
};
